import { useCustomNotificationToast } from '../hooks/useCustomNotificationToast';

// Global reference for the custom notification toast
export let globalNotificationToast: ReturnType<
  typeof useCustomNotificationToast
> | null = null;

export const setGlobalNotificationToast = (
  toast: ReturnType<typeof useCustomNotificationToast>
) => {
  globalNotificationToast = toast;
};
